import './bigboar/style';
import FormStructure from './bigboar/form_structure';

export default FormStructure;